import { createStyles, Theme } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
    },

    labelRoot: {
      color: colours.neutral[900],
      fontSize: 14,
      fontWeight: 500,
      lineHeight: '16px',
    },
    labelError: {},
  });
